document.addEventListener('DOMContentLoaded', () => {
  // Menu mobile
  const toggle = document.querySelector('[data-menu-toggle]');
  const nav = document.querySelector('[data-nav]');
  if (toggle && nav) {
    toggle.addEventListener('click', () => {
      const open = nav.classList.toggle('is-open');
      toggle.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', String(open));
      document.body.classList.toggle('no-scroll', open);
    });
    nav.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', () => {
        nav.classList.remove('is-open');
        toggle.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
        document.body.classList.remove('no-scroll');
      });
    });
  }

  // Header : ombre au scroll
  const header = document.querySelector('[data-header]');
  if (header) {
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 12);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  // Animations au scroll (avec MutationObserver pour le contenu chargé dynamiquement)
  function observeRevealItems(root) {
    if (!('IntersectionObserver' in window)) {
      root.querySelectorAll('[data-reveal], [data-reveal-item]').forEach((el) => el.classList.add('is-visible'));
      return;
    }
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });
    root.querySelectorAll('[data-reveal], [data-reveal-item]').forEach((el) => {
      if (!el.classList.contains('is-visible')) observer.observe(el);
    });
  }
  observeRevealItems(document);
  if ('MutationObserver' in window) {
    new MutationObserver(() => observeRevealItems(document)).observe(document.body, { childList: true, subtree: true });
  }

  // Ajout panier en AJAX
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-add-to-cart]');
    if (!btn) return;
    const variantId = btn.getAttribute('data-variant-id');
    if (!variantId || btn.classList.contains('is-loading')) return;
    btn.classList.add('is-loading');
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{ id: variantId, quantity: 1 }],
          sections: ['cart-drawer-section'],
          sections_url: window.location.pathname,
        }),
      });
      if (!res.ok) throw new Error('Échec de l\'ajout au panier');
      const data = await res.json();
      refreshCartDrawer(data.sections && data.sections['cart-drawer-section']);
      await updateCartCount();
      btn.classList.remove('is-loading');
      btn.classList.add('is-success');
      setTimeout(() => btn.classList.remove('is-success'), 1800);
    } catch (err) {
      btn.classList.remove('is-loading');
      btn.classList.add('is-error');
      setTimeout(() => btn.classList.remove('is-error'), 1800);
    }
  });

  // Remplace le contenu du tiroir panier par la version fraîche renvoyée par
  // Shopify (Section Rendering API), pour que le tiroir reflète tout de suite
  // les ajouts faits depuis une carte produit (catalogue, accueil) sans avoir
  // à recharger la page.
  function refreshCartDrawer(sectionHtml) {
    if (!sectionHtml) return;
    const oldSection = document.getElementById('shopify-section-cart-drawer-section');
    if (!oldSection) return;
    const doc = new DOMParser().parseFromString(sectionHtml, 'text/html');
    const newSection = doc.getElementById('shopify-section-cart-drawer-section');
    if (newSection) {
      oldSection.replaceWith(newSection);
    }
  }

  async function updateCartCount() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      document.querySelectorAll('[data-cart-count]').forEach((el) => {
        el.textContent = cart.item_count;
      });
    } catch (err) {
      /* silencieux : le panier Shopify reste la source de vérité */
    }
  }

  // Fenêtre de contact (site-wide) — intercepte tout lien "Contact"
  const contactOverlay = document.getElementById('contactModalOverlay');
  if (contactOverlay) {
    const openContactModal = (e) => {
      if (e) e.preventDefault();
      contactOverlay.classList.add('is-open');
      contactOverlay.setAttribute('aria-hidden', 'false');
      document.body.classList.add('no-scroll');
    };
    const closeContactModal = () => {
      contactOverlay.classList.remove('is-open');
      contactOverlay.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('no-scroll');
    };
    document.addEventListener('click', (e) => {
      const link = e.target.closest('a');
      if (link && link.textContent.trim() === 'Contact') {
        openContactModal(e);
        return;
      }
      if (e.target.closest('[data-contact-close]') || e.target === contactOverlay) {
        closeContactModal();
      }
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') closeContactModal();
    });
  }
});
